import { NotificationBell } from '../../features/notifications/NotificationBell';
import { SoundToggle } from '../ui/SoundToggle';
import { ContextSwitcher } from './ContextSwitcher';
import { UserMenu } from './UserMenu';
import { Wordmark } from './Wordmark';

/** 56 px glass bar. Below 1024: wordmark; from 1024: context switcher. The avatar shows until the sidebar has its user row. */
export const TopBar = () => (
    <header className="glass sticky top-0 z-30 flex h-bar shrink-0 items-center justify-between gap-3 px-gutter">
        <div className="min-w-0">
            <div className="lg:hidden">
                <Wordmark />
            </div>
            <div className="hidden lg:block">
                <ContextSwitcher />
            </div>
        </div>
        <div className="flex items-center gap-2">
            <NotificationBell />
            <SoundToggle />
            <span className="xl:hidden">
                <UserMenu variant="avatar" />
            </span>
        </div>
    </header>
);
